<!-- Error page-->
<div class="misc-wrapper">
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <h2 class="mb-1">{{'PAGE_NOT_FOUND' | translate}} 🕵🏻‍♀️</h2>
      <p class="mb-2">{{'PAGE_NOT_FOUND_MESSAGE' | translate}}</p>
      <a class="btn btn-primary mb-2 btn-sm-block" routerLink="/" rippleEffect>{{'BACK_TO_HOME_BUTTON' | translate}}</a><img class="img-fluid"
        [src]="coreConfig.layout.skin === 'dark' ? 'assets/images/pages/error-dark.svg' : 'assets/images/pages/error.svg'" alt="Error page" />
    </div>
  </div>
</div>
<!-- / Error page-->